module.exports = __webpack_public_path__ + "img/tese.05ee0c46.png";